import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { colors, fonts } from 'theme/Variables';

const CustomTypography = styled(Typography)`
    color: ${({ customcolor }) => customcolor || colors.primary['900']} !important;
    width: ${({ width }) => (width ? `${width}%` : '100%')};
    font-size: ${({ fontSize }) => (fontSize ? `${fontSize}rem` : '1.6rem')} !important;
    font-family: ${({ customfont }) => (customfont ? fonts.primary : fonts.secondary)} !important;
    padding: ${({ padding }) => (padding ? `${padding}px` : '0px')} !important;
    margin-top: ${({ mt }) => (mt ? `${mt}rem` : '0')} !important;
`;

export default CustomTypography;
